import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { Loader } from '../../../common/loader/loader.jsx';
import ExpertBlogJsx from './expertBlog.jsx'
import {baseURL} from "../../../../constants/applicationConstants"

export default class ExpertBlog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blogData: null,
            isProcessing: false,
            page: 1,
            blogType: 'ArticleByYou'
        }
    }

    getType = {
        ArticleByYou: '',
        Suggested: "trending"
    }

    getBlogData = () => {
        const urlName = localStorage.getItem("slugURL")
        const token = JSON.parse(localStorage.getItem('token'));

        this.setState({ isProcessing: true })

        axios.get(`${baseURL}/articles?page=${this.state.page}&limit=1000&type=${this.getType[this.state.blogType]}&expertid=${this.state.blogType !== 'Suggested' ? urlName.replace('/', '') : ''}`,
        {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ blogData: res.data?.data?.body, isProcessing: false });
        }).catch(err => {
            this.setState({ isProcessing: false })
        })




       
    }

    componentDidMount = () => {
        let token = JSON.parse(localStorage.getItem('token'));
        if (!token) {
            this.props.history.push("/");
        }
        this.getBlogData();
    }

    onPaginationButtonClick = (page) => {
        window.scrollTo(1200, 1200);
        this.setState({ page: page })
    }

    onBlogTypeClick = (title) => {
        this.setState({ blogType: title, page: 1 }, () => this.getBlogData());
    }

    render() {
        return (
            <div>
                <ExpertBlogJsx
                    blogData={this.state.blogData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    blogType={this.state.blogType}
                    onBlogTypeClick={this.onBlogTypeClick}
                    page={this.state.page}
                />
                {this.state.isProcessing && <Loader />}
            </div>
        )
    }
}